module.exports = __webpack_public_path__ + "static/media/31.d9e82982.svg";